export const GET_COUNTRY_DATA = "GET_COUNTRY_DATA";
export const SET_COUNTRY_DATA = "SET_COUNTRY_DATA";
export const GET_COMPLETE_STATE_DATA = "GET_COMPLETE_STATE_DATA";
export const SET_COMPLETE_STATE_DATA = "SET_COMPLETE_STATE_DATA";
export const GET_COMPLETE_CITY_DATA = "GET_COMPLETE_CITY_DATA";
export const SET_COMPLETE_CITY_DATA = "SET_COMPLETE_CITY_DATA";
export const GET_COMPLETE_PIN_CODE_DATA = "GET_COMPLETE_PIN_CODE_DATA";
export const SET_COMPLETE_PIN_CODE_DATA = "SET_COMPLETE_PIN_CODE_DATA";
export const GET_CUMULATION_DATA = "GET_CUMULATION_DATA";
export const SET_CUMULATION_DATA = "SET_CUMULATION_DATA";